import React, { useEffect, useState } from 'react';
import './result_page.css';
import Results from './Results';
import axios from 'axios';
import Searchbar from './Searchbar';
import Filter from '../filter/Filter';

function toList(str) {
    if (!str) return [];
    let lst = str.split(',');
    return lst.map(Number);
}

function ResultsPage({ location }) {

    const urlParams = new URLSearchParams(location.search);
    const keywordParam = urlParams.get('keyword') || '';
    const city = toList(urlParams.get('city'));
    const category = toList(urlParams.get('category'));
    const min_spending = urlParams.get('min_spending') || '';
    const max_spending = urlParams.get('max_spending') || '';

    const [pois, setPOIs] = useState([{ id: -1, name: 'loading' }]);

    useEffect(() => {
        const params = location.search
        getPOIs(params);
    }, [location])

    const getPOIs = async (filter) => {
        axios
            .get(`https://liwat-id-backend.herokuapp.com/api/info${filter}`)
            .then((res) => {
                setPOIs(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    return (
        <div className="result-page">
            <Searchbar initialKeyword={keywordParam} />
            <div className="d-flex">
                <Filter
                    keyword={keywordParam}
                    city={city}
                    category={category}
                    min_spending={min_spending}
                    max_spending={max_spending}
                    setPOIs={setPOIs}
                />
                <Results poiList={pois} />
            </div>
        </div>
    );
}

export default ResultsPage;
